export const
    GET_CALIBRATIONS_TYPES_DICTIONARY_FAILURE= "GET_CALIBRATIONS_TYPES_DICTIONARY_FAILURE",
    GET_CALIBRATIONS_TYPES_DICTIONARY_REQUEST= "GET_CALIBRATIONS_TYPES_DICTIONARY_REQUEST",
    GET_CALIBRATIONS_TYPES_DICTIONARY_SUCCESS= "GET_CALIBRATIONS_TYPES_DICTIONARY_SUCCESS",
    GET_COMPLAINTS_TYPES_DICTIONARY_FAILURE= "GET_COMPLAINTS_TYPES_DICTIONARY_FAILURE",
    GET_COMPLAINTS_TYPES_DICTIONARY_REQUEST= "GET_COMPLAINTS_TYPES_DICTIONARY_REQUEST",
    GET_COMPLAINTS_TYPES_DICTIONARY_SUCCESS= "GET_COMPLAINTS_TYPES_DICTIONARY_SUCCESS",
    GET_COURIERS_FAILURE= "GET_COURIERS_FAILURE",
    GET_COURIERS_REQUEST= "GET_COURIERS_REQUEST",
    GET_COURIERS_SUCCESS= "GET_COURIERS_SUCCESS",
    GET_CUSTOMERS_TYPES_DICTIONARY_FAILURE= "GET_CUSTOMERS_TYPES_DICTIONARY_FAILURE",
    GET_CUSTOMERS_TYPES_DICTIONARY_REQUEST= "GET_CUSTOMERS_TYPES_DICTIONARY_REQUEST",
    GET_CUSTOMERS_TYPES_DICTIONARY_SUCCESS= "GET_CUSTOMERS_TYPES_DICTIONARY_SUCCESS",
    GET_QUANTITY_CORRECTIONS_PROPOSALS_DICTIONARY_FAILURE= "GET_QUANTITY_CORRECTIONS_PROPOSALS_DICTIONARY_FAILURE",
    GET_QUANTITY_CORRECTIONS_PROPOSALS_DICTIONARY_REQUEST= "GET_QUANTITY_CORRECTIONS_PROPOSALS_DICTIONARY_REQUEST",
    GET_QUANTITY_CORRECTIONS_PROPOSALS_DICTIONARY_SUCCESS= "GET_QUANTITY_CORRECTIONS_PROPOSALS_DICTIONARY_SUCCESS",
    GET_SETTING_VALUE_FAILURE= "GET_SETTING_VALUE_FAILURE",
    GET_SETTING_VALUE_REQUEST= "GET_SETTING_VALUE_REQUEST",
    GET_SETTING_VALUE_SUCCESS= "GET_SETTING_VALUE_SUCCESS",
    GET_ALLOW_MULTIPLE_COMPLAINT_POSITION_REQUEST= "GET_ALLOW_MULTIPLE_COMPLAINT_POSITION_REQUEST",
    GET_ALLOW_MULTIPLE_COMPLAINT_POSITION_FAILURE= "GET_ALLOW_MULTIPLE_COMPLAINT_POSITION_FAILURE",
    GET_ALLOW_MULTIPLE_COMPLAINT_POSITION_SUCCESS= "GET_ALLOW_MULTIPLE_COMPLAINT_POSITION_SUCCESS",
    GET_IS_MY_COMPANY_NOT_FOUND_CHECKBOX_VISIBLE_REQUEST = "GET_IS_MY_COMPANY_NOT_FOUND_CHECKBOX_VISIBLE_REQUEST",
    GET_IS_MY_COMPANY_NOT_FOUND_CHECKBOX_VISIBLE_SUCCESS = "GET_IS_MY_COMPANY_NOT_FOUND_CHECKBOX_VISIBLE_SUCCESS",
    GET_IS_MY_COMPANY_NOT_FOUND_CHECKBOX_VISIBLE_FAILURE = "GET_IS_MY_COMPANY_NOT_FOUND_CHECKBOX_VISIBLE_FAILURE",
    GET_IS_SERIAL_NUMBER_TOOLTIP_VISIBLE_REQUEST = "GET_IS_SERIAL_NUMBER_TOOLTIP_VISIBLE_REQUEST",
    GET_IS_SERIAL_NUMBER_TOOLTIP_VISIBLE_SUCCESS = "GET_IS_SERIAL_NUMBER_TOOLTIP_VISIBLE_SUCCESS",
    GET_IS_SERIAL_NUMBER_TOOLTIP_VISIBLE_FAILURE = "GET_IS_SERIAL_NUMBER_TOOLTIP_VISIBLE_FAILURE",
    GET_TERM_OF_USE_URL_FAILURE= "GET_TERM_OF_USE_URL_FAILURE",
    GET_TERM_OF_USE_URL_REQUEST= "GET_TERM_OF_USE_URL_REQUEST",
    GET_TERM_OF_USE_URL_SUCCESS= "GET_TERM_OF_USE_URL_SUCCESS";


// WEBPACK FOOTER //
// ./src/types/Util.js